import React from 'react';
import { MapPin, Mail, Phone, Download } from 'lucide-react';
import { Button } from './ui/button';
import { personalInfo } from '../data/mock';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center">
          {/* Profile Image */}
          <div className="mb-8">
            <img
              src={personalInfo.profileImage}
              alt={personalInfo.name}
              className="w-32 h-32 rounded-full mx-auto object-cover shadow-lg hover:scale-105 transition-transform duration-300"
            />
          </div>

          {/* Main Heading */}
          <h1 className="text-6xl md:text-8xl font-light text-black mb-4 tracking-tight leading-tight">
            {personalInfo.name}
          </h1>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-light text-gray-600 mb-6 tracking-wide">
            {personalInfo.title}
          </h2>

          {/* Tagline */}
          <p className="text-lg md:text-xl text-gray-500 mb-12 max-w-4xl mx-auto leading-relaxed">
            {personalInfo.tagline}
          </p>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-gray-600">
            <div className="flex items-center space-x-2">
              <MapPin size={18} />
              <span>{personalInfo.location}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail size={18} />
              <span>{personalInfo.email}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Phone size={18} />
              <span>{personalInfo.phone}</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Button
              onClick={() => document.querySelector('#projects').scrollIntoView({ behavior: 'smooth' })}
              className="bg-black text-white hover:bg-gray-800 transition-colors duration-300 px-8 py-3 text-lg"
            >
              View My Work
            </Button>
            <Button
              variant="outline"
              className="border-black text-black hover:bg-black hover:text-white transition-all duration-300 px-8 py-3 text-lg"
            >
              <Download size={18} className="mr-2" />
              Download CV
            </Button>
          </div>

          {/* Abstract Geometric Element */}
          <div className="mt-16 flex justify-center">
            <div className="w-24 h-24 border border-gray-300 rounded-full flex items-center justify-center hover:rotate-45 transition-transform duration-500">
              <div className="w-12 h-12 border border-gray-400 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;